<!-- TOP ベネ通販タブ -->
<template>
  <div class="c-shop-search c-card__content">
    <div class="c-card__inner">
      <div class="c-shop-search__category c-shop-search__param">
        <div class="c-shop-search__param__label">カテゴリ</div>
        <div class="c-select">
          <select
            class="c-select__control"
            v-model="form.catMidClassCd"
            @change="onChangeMidCat($event)"
            :disabled="middleCategoryList.length === 0"
          >
            <option selected value="" class="default">中カテゴリ</option>
            <option
              v-for="(middle, i) in middleCategoryList"
              :key="`middle-${i}`"
              :value="middle.catClassCd"
            >
              {{ middle.name }}
            </option>
          </select>
        </div>
        <div class="c-select">
          <select
            class="c-select__control"
            v-model="form.catSmlClassCd"
            :disabled="form.catMidClassCd === '' || !smallCategory"
          >
            <option selected value="" class="default">小カテゴリ</option>
            <option
              v-for="(small, i) in smallCategory"
              :key="`small-${i}`"
              :value="small.catClassCd"
            >
              {{ small.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="c-shop-search__price c-shop-search__param">
        <div class="c-shop-search__param__label">ポイント</div>
        <div class="c-shop-search__input-wrapper">
          <div class="c-input">
            <input
              type="text"
              inputmode="numeric"
              v-model="form.priceFrom"
              @input="toNumFormatPriceFrom"
              :class="{
                'c-input__background': true,
                'c-input__background--error': formErrorPriceFrom
              }"
            />
          </div>
          <span class="c-shop-search__unit" wovn-ignore>{{ pointName }}</span>
        </div>

        <span class="c-shop-search__unit">〜</span>

        <div class="c-shop-search__input-wrapper">
          <div class="c-input">
            <input
              type="text"
              inputmode="numeric"
              v-model="form.priceTo"
              @input="toNumFormatPriceTo"
              :class="{
                'c-input__background': true,
                'c-input__background--error': formErrorPriceTo
              }"
            />
          </div>
          <span class="c-shop-search__unit" wovn-ignore>{{ pointName }}</span>
        </div>
      </div>
      <div class="c-shop-search__keyword p-toppage__search__main__row">
        <div class="p-toppage__search__main__keyword">
          <FormsKeywordSearch
            :placeholder="'商品名・ブランド・メニューNO（例：テレビ　型番）'"
            @input="inputKeyword"
            @onSearch="onSearch()"
            :background="true"
          />
        </div>
        <div v-if="formError" class="p-toppage__search__main__input--error">
          <span>
            <Icon name="alert" color="#CC0621" />
          </span>
          {{ formError }}
        </div>
      </div>
      <div class="p-toppage__search__main__row">
        <div class="p-toppage__search__main__keyword">
          <div class="c-checkbox">
            <label class="c-checkbox__inner">
              <input
                type="checkbox"
                v-model="form.chkCurrentPoint"
              />
              <span class="c-checkbox__box" />
              <span class="c-checkbox__label">現在のポイント内で探す </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uniqBy from "lodash/uniqBy";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import FormsKeywordSearch from "@/general/components/pages/KeywordSearch.vue";
import { getLargeCategories, getUserProfileSummary } from "@/general/store/api";
import LocalStorage from "@/general/utils/storage";

export default {
  name: "ShopBeneOnlineShop",
  components: {
    FormsKeywordSearch
  },
  props: {
    boCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      /**
       * カテゴリ一覧
       */
      categories: [],
      form: {
        keyword: "",
        /**
         * 大カテゴリ
         */
        catLrgClassCd: "115",
        /**
         * 選択中の中カテゴリ
         */
        catMidClassCd: "",
        /**
         * 選択中の小カテゴリ
         */
        catSmlClassCd: "",
        /**
         * 価格帯FROM
         */
        priceFrom: "",
        /**
         * 価格帯TO
         */
        priceTo: "",
        // /**
        //  * 割引率FROM
        //  */
        // discountFrom: "",
        // /**
        //  * 割引率TO
        //  */
        // discountTo: ""
        chkCurrentPoint: false
      },
      /**
       * 入力エラー
       */
      formError: "",
      formErrorPriceFrom: false,
      formErrorPriceTo: false,
      //   formErrorDiscountFrom: false,
      //   formErrorDiscountTo: false
      userSummary: {}
    };
  },
  computed: {
    /**
     * 中カテゴリ一覧
     * @returns {Array<object?>}
     */
    middleCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(this.categories, (item) => {
          if (
            item.level === 2 &&
            item.catLrgClassCd === this.form.catLrgClassCd
          ) {
            return item;
          }
        });
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /**
     * 小カテゴリ一覧
     * @returns {Array<object?>}
     */
    smallCategory() {
      if (this.categories.length) {
        const listFilter = filter(
          this.categories,
          (item) =>
            item.level === 3 &&
            item.catLrgClassCd === this.form.catLrgClassCd &&
            item.catMidClassCd === this.form.catMidClassCd
        );
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /**
     * ポイント名。指定がなければ"Point"
     * @return {string}
     */
    pointName() {
      return this.$store.state.commons.userInfo?.point_name || "Point";
    }
  },
  methods: {
    /**
     * カテゴリー一覧の取得
     */
    async getCategories() {
      //   const res = await this.$repositories("shop").getLargeCategories();
      //   if (res) {
      //     this.categories = res.data.categories || [];
      //   }

      const res = await getLargeCategories();
      console.log("res: ", res);
      if (res) {
        this.categories = res.categories || [];
      }
    },
    /**
     * 中カテゴリ変更イベント
     * @param {*} event
     */
    onChangeMidCat(event) {
      if (event.target.value === "") {
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      } else if (event.target.value !== "") {
        this.form.catMidClassCd = event.target.value;
        this.form.catSmlClassCd = "";
      }
    },
    /**
     * キーワード変更イベント
     * @param {*} args
     */
    inputKeyword(args) {
      this.form.keyword = args;
    },
    /**
     * 正数値かのチェック
     */
    isNumber(num) {
      if (num) {
        const number = Number(num);
        if (number >= 0) {
          if (!Number.isInteger(number)) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    /**
     * 入力チェック
     */
    validate() {
      this.formErrorPriceFrom = false;
      this.formErrorPriceTo = false;
      //   this.formErrorDiscountFrom = false;
      //   this.formErrorDiscountTo = false;
      // 必須チェック
      if (
        this.form.keyword == "" &&
        this.form.catMidClassCd == "" &&
        this.form.catSmlClassCd == "" &&
        this.form.priceFrom == "" &&
        this.form.priceTo == ""
      ) {
        return "カテゴリ等を選択するかキーワードをご入力ください。";
      }

      let hasNumError = false;
      if (!this.isNumber(this.form.priceFrom)) {
        hasNumError = true;
        this.formErrorPriceFrom = true;
      }
      if (!this.isNumber(this.form.priceTo)) {
        hasNumError = true;
        this.formErrorPriceTo = true;
      }
      if (hasNumError) {
        return "Pointは正数値で入力してください。";
      }

      // From/Toの整合性チェック
      console.log(this.form.priceFrom != "");
      console.log(this.form.priceTo != "");
      console.log(
        "Number(this.form.priceFrom) > Number(this.form.priceTo) = {} > {} = {}",
        Number(this.form.priceFrom),
        Number(this.form.priceTo),
        Number(this.form.priceFrom) > Number(this.form.priceTo)
      );
      if (
        this.form.priceFrom != "" &&
        this.form.priceTo != "" &&
        Number(this.form.priceFrom) > Number(this.form.priceTo)
      ) {
        this.formErrorPriceFrom = true;
        this.formErrorPriceTo = true;
        console.log(this.formErrorPriceFrom);
        console.log(this.formErrorPriceTo);
        return "Pointの範囲指定が不正です。";
      }

      return "";
    },
    getICPoints() {
      // ポイント取得
      let userPoint = 0;
      if (!this.userSummary) {
        this.userSummary = LocalStorage.getItem("userPointsDetails")
          ? JSON.parse(LocalStorage.getItem("userPointsDetails"))
          : "";
      }

      if (this.userSummary) {
        if (this.userSummary.grant_points > 0) {
          userPoint = this.userSummary.grant_points;
        }
        if (this.userSummary.thanks_points > 0) {
          userPoint += this.userSummary.thanks_points;
        }
        if (this.userSummary.kenko_points > 0) {
          userPoint += this.userSummary.kenko_points;
        }
      }
      return userPoint;
    },
    /**
     * 検索ボタンクリックイベント
     */
    onSearch() {
    // 現在のポイントで探すにチェックした場合、priceFromを空に、priceToに使用可能ポイントをセットする
      if (this.form.chkCurrentPoint) {
        this.form.priceFrom = "";
        this.form.priceTo = this.floorIC(this.getICPoints());
      }
      this.formError = this.validate();
      if (this.formError) {
        return;
      }
      if (this.form.priceFrom) {
        this.form.priceFrom = this.ceilIC(this.form.priceFrom);
      }
      if (this.form.priceTo) {
        this.form.priceTo = this.ceilIC(this.form.priceTo);
      }
      const paramsKeys = Object.keys(this.form),
        len = paramsKeys.length,
        params = [];

      for (let i = 0; i < len; i++) {
        params.push(`${paramsKeys[i]}=${this.form[paramsKeys[i]]}`);
      }
      params.push(`boCode=${this.boCode}`);

      const url =
        process.env.VUE_APP_SHOP_DOMAIN +
        "/product/list-goods?" +
        params.join("&");

      window.open(url, "_self");
    },
    /** 10の位を切り上げした数字を返す */
    ceilIC(amount) {
      // 10のくらいできりあげ
      if (amount == null || amount == 0) {
        return amount;
      }
      return Math.ceil(amount / 100) * 100;
    },
    /** 10の位を切り捨てた数字を返す */
    floorIC(amount) {
      // 10のくらいで切り捨てた切り捨て
      if (amount == null || amount == 0) {
        return amount;
      }
      return Math.floor(amount / 100) * 100;
    },
    convZenkakuNum(e) {
      if (e) {
        const hankakuNum = e.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        });
        const numStr = hankakuNum.replace(/[^0-9]/gi, "");
        if (numStr != "") {
          return String(Number(numStr));
        }
      }
      return "";
    },
    toNumFormatPriceFrom(e) {
      const numStr = this.convZenkakuNum(e.target.value);
      if (numStr != "") {
        this.form.priceFrom = numStr;
      } else {
        this.form.priceFrom = "";
      }
    },
    toNumFormatPriceTo(e) {
      const numStr = this.convZenkakuNum(e.target.value);
      if (numStr != "") {
        this.form.priceTo = numStr;
      } else {
        this.form.priceTo = "";
      }
    }
  },
  mounted() {
    this.getCategories();
    this.userSummary = getUserProfileSummary();
    this.userSummary = LocalStorage.getItem("userPointsDetails")
      ? JSON.parse(LocalStorage.getItem("userPointsDetails"))
      : "";
  }
};
</script>

<style lang="scss" scoped>
// @import "@/assets/css/_object/_component/c-shop-search";
// @import "@/assets/css/_object/_component/c-input";

// assets/css/_object/_component/c-shop-search
.c-shop-search {
  position: relative;
  padding: 1rem;

  &__param {
    display: flex;
    margin-bottom: 1rem;

    &__label {
      height: 40px;
      line-height: 40px;
      vertical-align: middle;
      width: 120px;
    }

    .c-input {
      display: inline-block;
    }
  }

  .c-select {
    width: calc(100% / 3 - 0.5rem);
    margin-right: 0.5rem;
    vertical-align: middle;
  }

  &__unit {
    height: 40px;
    line-height: 40px;
    margin-left: 0.25rem;
    margin-right: 1rem;
    @include mq() {
      line-height: normal;
      font-size: 0.875rem;
    }
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  @include mq() {
    .c-shop-search__param {
      display: block;
    }

    &__category {
      .c-shop-search__param__label {
        display: none;
      }

      .c-select {
        margin-bottom: 0.5rem;
        width: 100%;
      }
    }

    &__price,
    &__discount-rate {
      .c-shop-search__input-wrapper {
        margin-bottom: 0.5rem;
        width: 100%;
      }
      .c-input {
        display: inline-block;
        width: calc(100% - 80px);
      }
    }
  }
}

// assets/css/_object/_component/c-input
$Red: #da291c;
$CoolBlack: #1f2021;
$CoolGray3: #cacccf;
$CoolGray6: #f4f5f6;
$ErrorBg: #fae6e9;

$radiusSizeSm: 0.25rem;
$radiusSizeMd: 0.5rem;

.c-input {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  > * {
    height: 100%;
  }
  input[type="text"]:focus {
    outline: none;
  }

  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="url"],
  input[type="tel"],
  input[type="number"],
  textarea,
  select {
    padding: 0.5rem;
    width: 100%;
    border: 1px solid $CoolGray3;
    border-radius: $radiusSizeSm;
    color: $CoolBlack;
    line-height: 1.8;
    overflow: hidden;
    &::placeholder {
      color: $CoolGray3;
    }
  }

  input[type="text"],
  input[type="password"],
  input[type="email"],
  input[type="url"],
  input[type="tel"],
  input[type="number"],
  textarea {
    background-color: #fff;
  }

  textarea {
    min-height: 8rem;
    resize: vertical;
  }

  .c-input__selectLabel {
    position: relative;
    z-index: 0;
    display: block;
    width: 100%;
    background-color: #fff;
    border-radius: $radiusSizeSm;
    overflow: hidden;

    select {
      position: relative;
      z-index: 2;
      padding-right: 2rem;
      background-color: transparent;
    }
  }

  .c-input__selectLabel__arrow {
    z-index: 1;
    position: absolute;
    top: 50%;
    right: 1rem;
    margin-top: -0.75rem;
    width: 1.5rem;
    height: 1.5rem;
  }

  &__searchlabel {
    font-weight: bold;
    @include mq("lg", "min") {
      display: block;
    }
    @include mq("lg") {
      display: block;
    }
    @include mq() {
      display: none;
    }
  }

  &.c-input--group {
    input[type="text"],
    input[type="password"],
    input[type="search"],
    input[type="email"],
    input[type="url"],
    input[type="tel"],
    input[type="number"] {
      padding: 0.75rem 1rem;
    }

    .c-input__text {
      &:first-child {
        height: 3rem;
        border-radius: $radiusSizeMd 0 0 $radiusSizeMd;
        input[type="text"],
        input[type="password"],
        input[type="search"],
        input[type="email"],
        input[type="url"],
        input[type="tel"],
        input[type="number"],
        textarea,
        select {
          border-radius: $radiusSizeMd 0 0 $radiusSizeMd;
        }
      }
      &:last-child {
        border-radius: 0 $radiusSizeMd $radiusSizeMd 0;
        input[type="text"],
        input[type="password"],
        input[type="search"],
        input[type="email"],
        input[type="url"],
        input[type="tel"],
        input[type="number"],
        textarea,
        select {
          border-radius: 0 $radiusSizeMd $radiusSizeMd 0;
        }
      }
    }
    .c-input__button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.75rem;
      background-color: $Red;
      color: #fff;
      height: 3rem;
      .c-icon {
        &:not(:last-child) {
          margin-right: 0.5rem;
        }
        g {
          fill: #fff;
        }
      }
      &:hover {
        color: #fff;
        cursor: pointer;
      }
      &:first-child {
        border-radius: $radiusSizeMd 0 0 $radiusSizeMd;
      }
      &:last-child {
        border-radius: 0 $radiusSizeMd $radiusSizeMd 0;
      }
      @include mq("md", "min") {
        min-width: 5em;
      }
      @include mq() {
        min-width: 3em;
      }
    }
  }

  &.c-input--transparent {
    input[type="text"],
    input[type="password"],
    input[type="email"],
    input[type="url"],
    input[type="tel"],
    input[type="number"],
    textarea {
      background-color: transparent;
      border: none;
    }
  }
  &__background {
    background: $CoolGray6 !important;
    &:focus {
      background-color: #fff7f7 !important;
      border: 1px solid $Red !important;
    }
    &--error {
      background: $ErrorBg !important;
    }
  }
}
</style>
